import auth from "../../../../Auth";
import * as React from "react";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
// import ReactExport from "react-data-export";
import ReactExport from "react-export-excel-fixed-xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPlusCircle,
    faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import { MenuRender } from "../../../../Shared/GridComponents/CommonComponents";
import { LocalizationResource, ReqStatus } from "../../../../Shared/AppConstants";
import { dateFormatter, history} from "../../../../../HelperMethods";
import { AppPermissions } from "../../../../Shared/Constants/AppPermissions";
import { EDIT_RELEASE } from "../../../../Shared/ApiUrls";
import { LocalizationHelper } from "../../../../../Localization/helpers/LocalizationHelper";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export const ExportExcel = (data?) => (
    <ExcelFile
        element={
            <div className="pb-1 pt-1 w-100 myorderGlobalicons">
                <FontAwesomeIcon icon={faFileExcel} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Export to Excel{" "}
            </div>
        }
        filename="Manage Release Configuration"
    >
        <ExcelSheet data={data} name="Manage Release Configuration">
            <ExcelColumn label="Client" value="client" />
            <ExcelColumn label="Division" value="division" />
            <ExcelColumn label={LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")} value="location" />
            <ExcelColumn label="Position" value="position" />
            <ExcelColumn label="Tags" value="tags" />
            <ExcelColumn label="Created Date" value={(col) => col.createdDate ? dateFormatter(col.createdDate) : ""} />
            <ExcelColumn label="Created By" value="createdBy" />
        </ExcelSheet>
    </ExcelFile>
);

export const AddNewRelease = () => {
    return (
        <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick = {() => history.push('/admin/releaseconfig/create')}>
            <FontAwesomeIcon icon={faPlusCircle} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Add New Release{" "}
        </div>
    );
};

export const CustomMenu = (excelData ) => {
    return (
        <Menu openOnClick={true} className="actionItemMenu actionItemMenuThreeDots">
            <MenuItem render={MenuRender}>
            {auth.hasPermissionV2(AppPermissions.ADMIN_REQ_RELEASE_CREATE) && <MenuItem render={AddNewRelease}  />}
                <MenuItem render={() => ExportExcel(excelData)} />
            </MenuItem>
        </Menu>
    );
};


export function DefaultActions(props) {
    const { dataItem } = props;
    var defaultActions = [
        {
            action: "Edit",
            permCode: AppPermissions.CLIENT_LOC_UPDATE,
            nextState: "",
            icon: "faPencilAlt",
            linkUrl: `${EDIT_RELEASE}${dataItem.id}`,
        },
        {
            action: "Remove",
            permCode: AppPermissions.CLIENT_LOC_DELETE,
            nextState: "",
            icon: "faTrashAlt",
            cssStyle: { display: dataItem.status != ReqStatus.DRAFT ? "block" : "none" },
        },
    ];
    return defaultActions;
}